<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n();
useHead({
  titleTemplate: () => t("seo.layouts./viber-business-calls.title"),
  meta: [
    { name: "description", content: () => t("seo.layouts./viber-business-calls.description") },
    {
      property: "og:title", content: () => t("seo.layouts./viber-business-calls.title")
    },
    { property: "og:description", content: () => t("seo.layouts./viber-business-calls.description") },
    {
      property: "og:image",
      content:
        "https://cdn-web.smsbat.com/uploads/2024/viber_call.png",
    },
    { property: "og:image:width", content: "2404" },
    { property: "og:image:height", content: "2319" },
    { property: "og:image:type", content: "image/png" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:site", content: "@smsbatcom" },
  ],
});
onMounted(() => {
  const el = document.querySelector("body")
  el?.scrollIntoView()
  if (globalThis.location.hash) {
    const el = document.querySelector(globalThis.location.hash)
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: 'smooth' })
      }, 500)
    }
  }
})
</script>

<template>
  <div>

    <div class="main-banner">
      <div class="main-banner-content">
        <div class="banner-text">
          <div class="banner-title">
            {{ $t('bc.title') }}
          </div>
          <div class="banner-description">
            {{ $t('bc.subtitle') }}
          </div>
          <div class="banner-action">
            <NuxtLink class="nav-link button filled whitespace-nowrap !text-sm">
              <p>{{ $t('actions.tryForFree') }}</p>
            </NuxtLink>
            <NuxtLink to="viber://chat?service=26076" class="button outlined" external>{{
              $t('actions.contactUs') }}
            </NuxtLink>
          </div>
        </div>
        <div class="banner-image-container">
          <img src="https://cdn-web.smsbat.com/uploads/2024/viber_call.webp"
            :alt="`${$t('bc.title')} 19`"
            :title="`${$t('bc.title')}, ${$t('global.image')} 19`" />
        </div>
      </div>
    </div>

    <div class="page-section service-advantages">
      <div class="container">
        <div class="section-content">
          <div class="advantages-title">
            {{ $t('bc.advantages.title') }}
          </div>
          <div class="advantages-list">
            <div class="advantage-item">
              <div class="item-count">01</div>
              <div class="item-text">
                {{ $t('bc.advantages.elems[0]') }}
              </div>
            </div>
            <div class="advantage-item">
              <div class="item-count">02</div>
              <div class="item-text">
                {{ $t('bc.advantages.elems[1]') }}
              </div>
            </div>
            <div class="advantage-item">
              <div class="item-count">03</div>
              <div class="item-text">
                {{ $t('bc.advantages.elems[2]') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-image-container-second">
      <img src="https://cdn-web.smsbat.com/uploads/2024/viber_call-numberlookup.webp"
        :alt="`${$t('bc.title')} 20`" :title="`${$t('bc.title')} 20`" />
    </div>
    <div class="page-title !my-8 md:mb-16 w-[90%] md:w-1/2 mx-auto">
      {{ $t('bc.points.title') }}
    </div>

    <div class="page-section service-types">
      <div class="container">
        <div class="mail-bg-img"></div>
        <div class="phone-bg-img"></div>
        <div class="types-content">
          <div class="types-img">
            <NuxtImg src="/images/service-type.png" width="80" height="80" format="webp" loading="lazy" alt="Service Delivery Image" />
          </div>
          <div class="service-list">
            <div class="service-item !p-5 flex flex-col"><span class="text-blue-700 font-bold">{{
              $t('bc.points.elems[0].title') }}</span>{{ $t('bc.points.elems[0].text') }}</div>
            <div class="service-item !p-5 flex flex-col"><span class="text-blue-700 font-bold">{{
              $t('bc.points.elems[1].title') }}</span>{{ $t('bc.points.elems[1].text') }}</div>
          </div>
          <div class="service-list">
            <div class="service-item !p-5 flex flex-col"><span class="text-blue-700 font-bold">{{
              $t('bc.points.elems[2].title') }}</span>{{ $t('bc.points.elems[2].text') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-section service-domain" id="rates">
      <div class="container">
        <div class="service-price">
          <div class="price-label">{{ $t('global.price') }}</div>
        </div>
        <div class="section-head text-center">
          <div class="section-head-title after:opacity-0">{{ $t('bc.ratesTitle') }}</div>
        </div>
      </div>
    </div>

    <div class="mb-10">
      <BCDefaultRatesTable />
    </div>

    <div class="page-section">
      <div class="section-content">
        <div class="text-center">
          <NuxtLink :to="localePath('/register-bot')" class="nav-link">
            <p class="nav-link button filled w-1/3 mx-auto">{{ $t('links.registerBot') }}</p>
          </NuxtLink>
        </div>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.about-item img {
  width: 100%;
}

.banner-image-container {
  width: 100%;
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-image-container-second {
  padding: 20px;
  display: flex;
  justify-content: center;
  max-height: 1000px;

  img {
    object-fit: contain;
  }
}

@media (max-width: 900px) {
  .banner-image-container {
    margin-top: 50px;
  }
}

@media (max-width: 900px) {
  .main-banner-content {
    display: block;
  }
}

.main-banner .banner-text {
  margin-left: 0;
  align-self: center;
  max-width: 700px;
}

.main-banner-content {
  padding: 0;
}

@media (min-width: 768px) {
  .main-banner .banner-text {
    max-width: 500px;
  }
}

@media (min-width: 1170px) {
  .main-banner .banner-text {
    max-width: 500px;
  }
}

@media (min-width: 1300px) {
  .main-banner .banner-text {
    margin-left: calc((100% - 1300px) / 2);
    max-width: 700px;
  }
}
</style>
